/**
 * Created by bzm on 2015/9/9.
 */
'use strict';
angular.module("pieceMgr.multiDoc", ["pieceMgr.multiDocDir"])